import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  afterNextRender,
} from '@angular/core';
import Swiper from 'swiper';
import { Keyboard, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import { SubscribeComponent } from '@pyg-components/subscribe/subscribe.component';
import { ShareButtonsComponent } from '@pyg-shared/share-buttons/share-buttons.component';
import { TranslatePipe } from '@ngx-translate/core';
import { pygRange } from '@pyg-shared/utils';
import { BreakOnPipe } from '@pyg-pipes/break_on.pipe';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-future-of-telco',
  templateUrl: './future-of-telco.component.html',
  styleUrls: ['./future-of-telco.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    LangRouterLink,
    SubscribeComponent,
    ShareButtonsComponent,
    TranslatePipe,
    BreakOnPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FutureOfTelcoComponent {
  private readonly config: SwiperOptions = {
    modules: [Keyboard, Pagination],
    slidesPerView: 1.25,
    spaceBetween: 20,
    loop: true,
    grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    breakpoints: {
      '640': {
        slidesPerView: 2.25,
      },
      '1024': {
        slidesPerView: 3.25,
      },
    },
  };

  public readonly takeaways = pygRange(1, 7);
  public readonly testimonials = [
    { id: '1', image: 'jan_nekovar' },
    { id: '2', image: 'jan_gabauer' },
    { id: '3', image: 'roman_demeter' },
  ];

  constructor() {
    afterNextRender(() => {
      const swiper = new Swiper('.swiper', this.config);
      swiper.init();
    });
  }
}
